// extracted by mini-css-extract-plugin
export default {"shade":"ResourceBlackoutBar_shade__xtiXv","bar":"ResourceBlackoutBar_bar__eKet9","label":"ResourceBlackoutBar_label__1FTl4"};